module.exports = __webpack_public_path__ + "assets/img/23_143.138ce75d.jpg";